import { Fancybox } from '@fancyapps/ui'

function getItems(gallery) {
  try {
    return JSON.parse(gallery.dataset.csGallery || '[]')
  } catch (e) {
    return []
  }
}

// Show slide `index` in the main image box and highlight the matching thumbnail
function setMainImage(gallery, index) {
  const item = getItems(gallery)[index]
  if (!item) return

  const mainLink = gallery.querySelector('.js-cs-gallery-open')
  const mainImg = mainLink && mainLink.querySelector('img')
  if (mainLink) {
    mainLink.href = item.src
    mainLink.dataset.csGalleryIndex = index
  }
  if (mainImg) mainImg.src = item.src

  gallery.querySelectorAll('.js-cs-gallery-thumb').forEach(thumbLink => {
    const isActive = parseInt(thumbLink.dataset.csGalleryIndex, 10) === index
    thumbLink.parentElement.classList.toggle('is-active', isActive)
    if (isActive) scrollThumbIntoView(thumbLink.parentElement)
  })
}

// Scroll the thumbnail strip (not the page) so that `thumb` is fully visible
function scrollThumbIntoView(thumb) {
  const track = thumb.parentElement
  const thumbLeft = thumb.offsetLeft - track.offsetLeft
  const thumbRight = thumbLeft + thumb.offsetWidth

  if (thumbLeft < track.scrollLeft) {
    track.scrollLeft = thumbLeft
  } else if (thumbRight > track.scrollLeft + track.clientWidth) {
    track.scrollLeft = thumbRight - track.clientWidth
  }
}

function updateArrows(slider) {
  const track = slider.querySelector('.js-cs-thumbs')
  const prev = slider.querySelector('.js-cs-thumbs-prev')
  const next = slider.querySelector('.js-cs-thumbs-next')
  if (!track || !prev || !next) return

  prev.disabled = track.scrollLeft <= 1
  next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
}

function onArrowClick(event) {
  const arrow = event.target.closest('.js-cs-thumbs-prev, .js-cs-thumbs-next')
  if (!arrow) return

  const track = arrow.parentElement.querySelector('.js-cs-thumbs')
  const thumb = track && track.firstElementChild
  if (!thumb) return

  const step = thumb.offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0)
  const direction = arrow.classList.contains('js-cs-thumbs-prev') ? -1 : 1
  track.scrollLeft += step * direction
}

function initThumbSliders() {
  document.querySelectorAll('.cs-detail-hero__thumbs-slider.has-nav').forEach(slider => {
    const track = slider.querySelector('.js-cs-thumbs')
    if (!track) return
    track.addEventListener('scroll', () => updateArrows(slider), { passive: true })
    window.addEventListener('resize', () => updateArrows(slider))
    updateArrows(slider)
  })
}

function onThumbClick(event) {
  const thumbLink = event.target.closest('.js-cs-gallery-thumb')
  const gallery = thumbLink && thumbLink.closest('.js-cs-gallery')
  if (!gallery) return

  event.preventDefault()
  setMainImage(gallery, parseInt(thumbLink.dataset.csGalleryIndex, 10) || 0)
}

function onMainClick(event) {
  const mainLink = event.target.closest('.js-cs-gallery-open')
  const gallery = mainLink && mainLink.closest('.js-cs-gallery')
  if (!gallery) return

  const items = getItems(gallery)
  if (!items.length) return

  event.preventDefault()

  Fancybox.show(
    items.map(item => ({ ...item, type: 'image' })),
    {
      startIndex: parseInt(mainLink.dataset.csGalleryIndex, 10) || 0,
      infinite: true,
      mainClass: 'cs-gallery-lightbox',
      Thumbs: { autoStart: true },
      Toolbar: {
        display: ['counter', 'zoom', 'fullscreen', 'close'],
      },
      on: {
        // Keep the page gallery in sync with the slide viewed in the lightbox
        'Carousel.change': (fancybox, carousel, to) => setMainImage(gallery, to),
      },
    }
  )
}

export default function initCaseStudyGallery() {
  document.addEventListener('click', onThumbClick)
  document.addEventListener('click', onMainClick)
  document.addEventListener('click', onArrowClick)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbSliders)
  } else {
    initThumbSliders()
  }
}
